import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-success text-light py-4 mt-auto">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={4} className="mb-3 mb-lg-0">
            <span>&copy; Ronaldo Butrus {currentYear}</span>
          </Col>
          <Col xs={12} lg={4} className="mb-3 mb-lg-0">
            <div>
              <Link to="/" className="link-light text-decoration-none">Home</Link><br />
              <Link to="/portfolio" className="link-light text-decoration-none">Portfolio</Link><br />
              <Link to="/revision-notes" className="link-light text-decoration-none">Revision Notes</Link>
            </div>
          </Col>
          <Col xs={12} lg={4} className="mb-3 mb-lg-0">
            <div>
              <a href="https://github.com/ronaldobutrus" className="link-light text-decoration-none" target="_blank" rel="noopener noreferrer">GitHub</a><br />
              <a href="https://linkedin.com/in/ronaldobutrus" className="link-light text-decoration-none" target="_blank" rel="noopener noreferrer">LinkedIn</a><br />
              <a href="mailto:ronaldobutrus@gmail.com" className="link-light text-decoration-none">Email</a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer; 